import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import PipelineFormProvider, { usePipelineForm } from './PipelineFormContext'
import PipelineWorkspaceProvider, { usePipelineWorkspace } from './PipelineWorkspaceContext'
import PipelineChatProvider, { usePipelineChat } from './PipelineChatContext'

/**
 * Backward-compatible hook that merges all three context slices.
 * Prefer the granular hooks (usePipelineForm, usePipelineWorkspace, usePipelineChat)
 * in new code to avoid unnecessary re-renders.
 */
export const usePipelineEditor = () => {
  const form = usePipelineForm()
  const workspace = usePipelineWorkspace()
  const chat = usePipelineChat()

  return useMemo(() => ({
    ...form,
    ...workspace,
    ...chat,
    handleCreate: workspace.handleSave,
    applyPipelineFromChat: workspace.setProposedPipeline,
    isDirty: form.isFormDirty || workspace.isWorkspaceDirty
  }), [form, workspace, chat])
}

const PipelineEditorProvider = ({ initialValue, children }) => {
  return (
    <PipelineFormProvider initialValue={initialValue}>
      <PipelineWorkspaceProvider initialValue={initialValue}>
        <PipelineChatProvider>
          {children}
        </PipelineChatProvider>
      </PipelineWorkspaceProvider>
    </PipelineFormProvider>
  )
}

PipelineEditorProvider.propTypes = {
  children: PropTypes.node,
  initialValue: PropTypes.object
}

export default PipelineEditorProvider
